"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseReceivedEvent = void 0;
const Response_1 = require("./Response");
class ResponseReceivedEvent {
    constructor({ requestId, loaderId, timestamp, type, response: { url, status, statusText, headers, length, mimeType }, }) {
        this.requestId = requestId;
        this.loaderId = loaderId;
        this.timestamp = timestamp;
        this.response = new Response_1.Response({
            url,
            status,
            statusText,
            headers,
            encodedDataLength: length,
            mimeType: mimeType !== null && mimeType !== void 0 ? mimeType : 'text/html',
        });
        this.type = type;
        this.hasExtraInfo = false;
    }
}
exports.ResponseReceivedEvent = ResponseReceivedEvent;
